module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm9",
    attrs: {
      "id": "page_5"
    }
  }, [_c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm10"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0006#page_7"
    }
  }, [_vm._v("Introduction by Michael Phillips")])]), _vm._v(" "), _c('p', {
    staticClass: "fm10"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0007#page_19"
    }
  }, [_vm._v("Foreword by Professor George Adam Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "fm10"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0008#page_21"
    }
  }, [_vm._v("Preface by Ralph Connor")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0010#page_23"
    }
  }, [_vm._v("1. Christmas Eve in a Lumber Camp")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0011#page_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Battle for Black Rock Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0012#page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Plans")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0013#page_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Christmas Day Race")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0014#page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Christmas Service")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0015#page_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Mrs. Mavor's Story")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0016#page_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. The Making of the League")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0017#page_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Jim Craig's Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0018#page_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. An Old Story in a Stable")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0019#page_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. First Roll-Call of the Black Rock Church")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0020#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Spring of 1883")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0021#page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Breaking of the League")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0022#page_128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Graeme's Dangerous Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0023#page_134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. What Happened to Billy Breen")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0024#page_140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The New League")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0025#page_147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. What Came to Slavin")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0026#page_159",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. The Two Calls")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0027#page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. An Agonizing Decision")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0028#page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Love Is Not All")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0029#page_180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. How Nelson Came Home")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0030#page_188",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Graeme's Return Home")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0031#page_193",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. Graeme's New Birth")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0032#page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Travels")])]), _vm._v(" "), _c('p', {
    staticClass: "fm11"
  }, [_c('span', {
    staticClass: "calibre5",
    attrs: {
      "href": "#/text/part0033#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Homecoming")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54010ed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0005.vue
// module id = 75
// module chunks = 0